import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    body: [
      "Exserviceman Property Services respects your privacy. Any personal information you share with us through enquiry forms, phone, email or WhatsApp — such as your name, contact number and property requirements — is used only to respond to your enquiry and assist you with property-related services.",
      "We do not sell, rent or share your personal information with third parties for their marketing purposes. Information may be shared with property owners or relevant parties only where needed to fulfil your request.",
      "You may contact us at any time to request correction or deletion of your personal information.",
    ],
  },
  terms: {
    title: "Terms & Conditions",
    body: [
      "The content on this website is provided for general information about plot and land opportunities around Nagpur, Maharashtra. It does not constitute legal, financial or investment advice.",
      "Property details, pricing and availability shown on this website are indicative and subject to change and verification. Listings marked as sample listings are placeholders until live property data is published.",
      "Any decision to purchase property should be made only after independent verification of title, ownership, approvals, documentation, zoning and other legal aspects, preferably with the help of a qualified legal professional.",
      "By using this website you agree that Exserviceman Property Services is not liable for decisions made solely on the basis of the information presented here.",
    ],
  },
  disclaimer: {
    title: "Disclaimer",
    body: [
      "Property information, pricing, availability, approvals and other details are subject to verification and may change. Buyers are advised to independently verify title, ownership, approvals, documentation, zoning, access and other legal/property-related details before making any transaction.",
      "Nothing on this website constitutes a promise of returns, appreciation or profit. Any references to location advantages or connectivity are general in nature and should be independently verified.",
      "Images on this website may be representative and may not depict the exact property unless explicitly stated.",
    ],
  },
};

export default function Legal({ type }) {
  const page = CONTENT[type] || CONTENT.disclaimer;

  return (
    <main data-testid={`legal-${type}-page`} className="pt-[72px]">
      <div className="bg-navy py-14 text-white">
        <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
          <h1 className="font-display text-4xl font-bold tracking-tight">{page.title}</h1>
        </div>
      </div>
      <div className="mx-auto max-w-4xl px-4 py-14 sm:px-6 lg:px-8">
        <Link
          to="/"
          data-testid="legal-back-link"
          className="inline-flex items-center gap-2 text-sm font-semibold text-muted-foreground transition-colors hover:text-navy"
        >
          <ArrowLeft className="h-4 w-4" aria-hidden="true" />
          Back to Home
        </Link>
        <div className="mt-8 space-y-6">
          {page.body.map((para, i) => (
            <Reveal key={i} delay={i * 0.05}>
              <p className="text-base leading-relaxed text-muted-foreground">{para}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </main>
  );
}
